import * as Cookies from 'js-cookie';

export const setMerchantSelected = (id: string) => Cookies.set('merchantSelected', id);
export const getMerchantSelected = () => Cookies.get('merchantSelected');

export const setSiteSelected = (id: string) => Cookies.set('siteSelected', id);
export const getSiteSelected = () => Cookies.get('siteSelected');

export const setSessionActive = () => Cookies.set('sessionActive', 'true');
export const getSessionActive = () => Cookies.get('sessionActive');

const FORGE_AUTO_REDIRECT_COOKIE = 'forge_auto_redirect';
const FORGE_COOKIE_OPTIONS: Cookies.CookieAttributes = {
  domain: '.ingrid.com',
  path: '/',
  expires: 365,
  sameSite: 'Lax',
  secure: true,
};

export const setForgeAutoRedirect = () =>
  Cookies.set(FORGE_AUTO_REDIRECT_COOKIE, 'true', FORGE_COOKIE_OPTIONS);

export const getForgeAutoRedirect = () =>
  Cookies.get(FORGE_AUTO_REDIRECT_COOKIE) === 'true';

export const clearForgeAutoRedirect = () =>
  Cookies.remove(FORGE_AUTO_REDIRECT_COOKIE, { domain: '.ingrid.com', path: '/' });
